import { useEffect, useState, useCallback } from 'react';
import { RolesApi } from '../../clients';

export const useGetRolesForForms = (params = {}) => {
  const [state, setState] = useState({
    roles: [],
    loading: true,
    error: null,
  });

  const setPartialState = (updates) => {
    setState((prevState) => ({ ...prevState, ...updates }));
  };

  const fetchRoles = useCallback(async () => {
    setPartialState({
      loading: true,
      error: null,
    });

    try {
      const { data } = await RolesApi.getRolesForForms(params);
      setPartialState({
        roles: data.data || [],
        loading: false,
        error: null,
      });
    } catch (error) {
      console.error('Error fetching roles for forms:', error);
      setPartialState({
        loading: false,
        error: 'Failed to load roles',
        roles: [],
      });
    }
  }, [JSON.stringify(params)]);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  const refetch = useCallback(() => {
    fetchRoles();
  }, [fetchRoles]);

  return {
    ...state,
    refetch,
  };
};
